import React, { useEffect, useRef, useState } from "react";
import ChatNavbar from "./ChatNavbar";
import InputMessage from "./InputMessage";
import * as signalR from "@microsoft/signalr";
import { getActiveConverstionList } from "../../../Services/getActiveConverstionList";
import downloadIcon from "../../../../../assets/icons/downloadicon.png";
import pdfIcon from "../../../../../assets/icons/pdficon.png";
import bellSound from "../../../../../assets/audio/notification_tone.mp3";
import { API_BASE_URL } from "../../../../../config";
import { getMarkBusinessUserMsg } from "../../../Services/getMarkBusinessUserMsg";
import StartConversation from '../../../../../images/home-landing-page/start-conversation.png';
import EmptyProfileImage from '../../../../../images/navbar/empty-profile-image.png'
import { jwtDecode } from "jwt-decode";
import { getJobDetails } from "../../../../Message/Services/getJobDetails";
import { hireForJob } from "../../../../Message/Services/hireForJob";
import { getBusinessProfileData } from "../../../Services/getBusinessProfileData";
import Avatar2 from "../../../../Avatar/Avatar2";
import { formatMessageTime, formatDateSeparator, isDifferentDay } from '../../../../../utils/chatFormatters';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Index({
    activeConversation,
    setConversationSearchId,
    ChatSearching,
    setUnreadMessages,
    setNotification,
    notification,
    business,
    onBack
}) {
    const [messages, setMessages] = useState([]);
    const [connection, setConnection] = useState(null);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [messageText, setMessageText] = useState("");
    const [username, setUsername] = useState("");
    const [filePreview, setFilePreview] = useState(null);
    const [attachementUrl, setAttachmentUrl] = useState(null);
    const [textNoMsg, setTextNoMsg] = useState(false);
    const [reconnect, setReconnect] = useState(false);

    const [userLoggedInImage, setUserLoggedInImage] = useState(null);
    const [jobCardDetails, setJobCardDetails] = useState(null);

    const [isHiring, setIsHiring] = useState(false);
    const prevMessagesRef = useRef([]);
    const messageRefs = useRef({});

    const [page, setPage] = useState(1); // Keep track of the current page
    const [hasMoreMessages, setHasMoreMessages] = useState(true); // Flag to stop fetching
    const [isLoading, setIsLoading] = useState(false); // Prevent multiple fetches

    // Refs mirror state so fetchMessages always reads the CURRENT value,
    // not a stale closure captured at render time.
    const isLoadingRef = useRef(false);
    const hasMoreRef = useRef(true);

    const messagesEndRef = useRef(null);
    const chatContainerRef = useRef(null);

        const emojiOnlyRegex = /^(?:\p{Emoji_Presentation}|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Component}|\u200d)+$/u;



    const scrollToBottom = (behavior = "smooth") => {
        const c = chatContainerRef.current;
        if (c) {
            c.scrollTo({ top: c.scrollHeight, behavior: behavior });
        }
    };

    // Scroll to specific message when ChatSearching is active
    useEffect(() => {
        console.log("object", business);
        if (ChatSearching && ChatSearching.messageId) {
            const messageRef = messageRefs.current[ChatSearching.messageId];
            if (messageRef) {
                messageRef.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }, [ChatSearching]);





useEffect(() => {
    // These functions are still relevant and should be called.
    fetchJobDetails();

    if (activeConversation && currentUserId) {
        setConversationSearchId(activeConversation?.conversationId);
        if (sessionStorage.getItem('userImage') !== "null")
            setUserLoggedInImage(sessionStorage.getItem('userImage'));

        // 1. Reset State: Clear out messages from the previous conversation.
        setMessages([]);
        setPage(1);
        setHasMoreMessages(true);
        hasMoreRef.current = true;       // sync ref immediately
        isLoadingRef.current = false;    // allow new fetch
        setIsLoading(false);
        setTextNoMsg(false); // Assume there are messages until the fetch proves otherwise.

        // Ensure the scroll position is reset for the new conversation.
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }

        // 2. Fetch First Page: Call your new paginated fetch function for page 1.
        fetchMessages(activeConversation.conversationId, 1);


    }
}, [activeConversation, currentUserId]);




    const fetchJobDetails = async () => {
        try {
            const jobResponse = await getJobDetails(business.quoteId);
            if (jobResponse?.jobId)
                setJobCardDetails(jobResponse);
        }
        catch (error) {
            console.error(error);
        }
    }



const handleScroll = () => {
    const container = chatContainerRef.current;
    // If scrolled to the top and not currently loading, fetch more messages
    if (container.scrollTop === 0 && !isLoadingRef.current && hasMoreRef.current) {
        fetchMessages(activeConversation?.conversationId, page);
    }
};


const fetchMessages = async (convId, pageNum) => {
    // Use REFS (not state) for the guard so we always read the latest value,
    // even when called from a useEffect whose closure captured stale state.
    if (isLoadingRef.current || !hasMoreRef.current) {
        return;
    }

    console.log(`Starting fetch for page: ${pageNum}`);
    isLoadingRef.current = true;
    setIsLoading(true);

    try {
        const response = await getActiveConverstionList(convId, pageNum);
        console.log(`API response for page ${pageNum}:`, response);

        if (!Array.isArray(response)) {
            console.error("API Error: The response was not an array.", response);
            hasMoreRef.current = false;
            setHasMoreMessages(false);
            return;
        }

        if (response.length === 0) {
            console.log("Reached the end of messages.");
            hasMoreRef.current = false;
            setHasMoreMessages(false);
            if (pageNum === 1) setTextNoMsg(true);
            return;
        }

        setTextNoMsg(false);

        const formatMessages = response.map((msg) => ({
            id: msg.messageId,
            type: (msg.homeUserId == currentUserId) ? "user" : "receiver",
            message: msg.message,
            rawDate: msg.dated,
            messageTime: formatMessageTime(msg.dated),
            attachmentUrl: msg.attachmentUrl,
            attachmentName: msg.attachmentName,
            attachmentExtension: msg.attachmentExtension,
            messageId: msg.messageId,
            quoteId: msg.quoteId || business?.quoteId,
            conversationId: msg.conversationId || convId,
        }));

        // Keep track of the scroll height *before* adding new messages
        const chatContainer = chatContainerRef.current;
        const previousScrollHeight = chatContainer.scrollHeight;

        // Prepend the new (older) messages
        setMessages((prevMessages) => [...formatMessages, ...prevMessages]);

        // After the state updates, restore the scroll position
        // This stops the scrollbar from jumping to the top
        if (chatContainer) {
            chatContainer.scrollTop = chatContainer.scrollHeight - previousScrollHeight;
        }

        setPage((prevPage) => prevPage + 1);

        if (pageNum === 1) {
            setTimeout(() => scrollToBottom("auto"), 0);
            BusinessUserMessageRead(convId);
        }

    } catch (error) {
        console.error("Critical error in fetchMessages:", error);
        hasMoreRef.current = false;
        setHasMoreMessages(false);
    } finally {
        console.log("Executing finally block: Setting isLoading to false.");
        isLoadingRef.current = false;
        setIsLoading(false);
    }
};

    const BusinessUserMessageRead = async (conversationId) => {
        try {
            const response = await getMarkBusinessUserMsg(conversationId, null);
            console.log("response", response)

        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {

        const userType = "homeUser"; // Replace with dynamic value if necessary
        const token = localStorage.getItem('token');
        if (token !== null) {
            const decodeToken = jwtDecode(token);
            const userId = parseInt(decodeToken.nameid, 10);
            setUsername(decodeToken.UserName);
            setCurrentUserId(userId);

            // Set up the SignalR connection
            const connect = new signalR.HubConnectionBuilder()
                .withUrl(`${API_BASE_URL}/chatHub?userType=${userType}&userId=${userId}&quoteId=${business?.quoteId}`, {
                    withCredentials: true,
                })
                .withAutomaticReconnect()
                .build();
            setConnection(connect);

            // Start the connection
            connect
                .start()
                .then(() => console.log("Connected to chat hub"))
                .catch((err) => console.error("Connection failed: ", err));
            setReconnect(false)

            return () => {
                if (connect) {
                    connect.stop();
                }
            };
        }

    }, [business]);


useEffect(() => {
        if (connection) {
            const audio = new Audio(bellSound);
            const myUserType = "homeUser";

            const handleReceiveMessage = (response) => {
                // FIX #1: Ignore the "echo" of a message sent by the current user.
                // This is essential to prevent self-duplication on your own screen.
                if (response.senderUserId === currentUserId && response.senderUserType === myUserType) {
                    return; 
                }

                // --- Main Logic for Handling Incoming Messages ---

                // A) Is this message for the conversation we currently have open?
                if (response.conversationId === activeConversation?.conversationId) {


                    let finalAttachmentUrl = response?.attachmentUrl;
                    if (finalAttachmentUrl && !finalAttachmentUrl.startsWith('http') && !finalAttachmentUrl.startsWith('data:')) {
                        finalAttachmentUrl = `${API_BASE_URL}${finalAttachmentUrl.startsWith('/') ? '' : '/'}${finalAttachmentUrl}`;
                        console.log("Constructed SignalR Attachment URL for Home User:", finalAttachmentUrl);
                    }


                    // Use the functional update form of setMessages to guarantee you have the latest state.
                    setMessages((prevMessages) => {
                        // Check if this message has already been added to prevent any race conditions.
                        const messageExists = prevMessages.some(msg => msg.messageId === response.messageId);

                        if (messageExists) {
                            return prevMessages; // If it already exists, return the state unchanged.
                        }

                        // If it's a new message, add it to the state array.
                        return [
                            ...prevMessages,
                            {
                                id: prevMessages.length + 1,
                                type: "receiver", // For the Home User, any incoming message is from the "receiver"
                                message: response?.message,
                                rawDate: response?.messageTime,
                                messageTime: formatMessageTime(response?.messageTime),
                                attachmentUrl: finalAttachmentUrl,
                                attachmentExtension: response?.attachmentExtension,
                                messageId: response.messageId, // Include for the 'messageExists' check
                                quoteId: response?.quoteId || business?.quoteId,
                                conversationId: response?.conversationId || activeConversation?.conversationId
                            },
                        ];
                    });

                    scrollToBottom();


                } 
                // B) If it's for a different, inactive conversation, trigger a notification.
                else {
                    if (!activeConversation || response.conversationId !== activeConversation.conversationId) {
                        setUnreadMessages({ num: 1, conversationId: response.conversationId });
                        audio.play().catch((error) => console.error("Error playing sound:", error));
                    }
                }
            };

            // Attach the single, smart listener.
            connection.on("ReceiveMessage", handleReceiveMessage);

            // The cleanup function will remove this specific listener when the component unmounts.
            return () => {
                connection.off("ReceiveMessage", handleReceiveMessage);
            };
        }
    // FIX #2: Stable dependency array. This hook will not re-run every time a new
    // message arrives, which prevents the multiple-listener bug.
    }, [connection, activeConversation, business, currentUserId, setUnreadMessages]);


    const clickToHire = async (jobId) => {
        try {
            setIsHiring(true);
            const businessData = await getBusinessProfileData(activeConversation.businessId);
            // Hire the candidate for the job
            await hireForJob(jobId, activeConversation.businessId);
            fetchJobDetails();

            // Ensure connection is active before sending message
            if (connection && connection.state === signalR.HubConnectionState.Connected) {
                const hireMessage = `${businessData?.model.businessName} - Hired for the Job`;

                await connection.invoke(
                    "SendPrivateMessage",
                    business?.userId,
                    hireMessage,
                    null,
                    null,
                    business?.userType,
                    business?.quoteId,
                    activeConversation?.conversationId // Add the conversationId here
                );

                // Ensure the message is added to the local state
                setMessages((prevMessages) => [
                    ...prevMessages,
                    {
                        senderUserId: prevMessages.length + 1,
                        Username: username,
                        type: "user",
                        message: hireMessage,
                        ProfilePictureUrl: "https://google.com",
                        rawDate: new Date().toISOString(),
                        messageTime: formatMessageTime(new Date().toISOString()),
                        attachmentUrl: null,
                        // Add the IDs here
                        quoteId: business?.quoteId,
                        conversationId: activeConversation?.conversationId
                    },
                ]);

                // // Wait a moment for the message to be processed, then refresh the conversation
                // setTimeout(() => {
                //     fetchActiveConversation(activeConversation?.conversationId);
                // }, 500); // Small delay to ensure message is stored before refetching
            }
        } catch (error) {
            console.error("Error during hiring process:", error);
        }
        finally {
            isHiring(false);
        }
    };

    const handleSendMessage = async (
        messageText,
        base64File = null,
        fileName = null
    ) => {

        if (!connection || connection.state !== signalR.HubConnectionState.Connected) {
            //alert("Connection is not active. Reconnecting...");
            toast.error("Not connected. Message will be sent once connection is restored.");
            //setReconnect(true)
            return;
        }

        if (connection.state === signalR.HubConnectionState.Connected) {
            try {
                await connection.invoke(
                    "SendPrivateMessage",
                    business?.userId,
                    messageText,
                    base64File,
                    fileName,
                    business?.userType,
                    business?.quoteId,
                    activeConversation?.conversationId // Add the conversationId here
                );
                setMessages((prevMessages) => [
                    ...prevMessages,
                    {
                        senderUserId: prevMessages.length + 1,
                        Username: username,
                        type: "user",
                        message: messageText,
                        fileName: fileName,
                        fileUrl: base64File,
                        ProfilePictureUrl: "https://google.com",
                        rawDate: new Date().toISOString(),
                        messageTime: formatMessageTime(new Date().toISOString()),
                        attachmentUrl: attachementUrl,
                        // Add the IDs here
                        quoteId: business?.quoteId, // Can be null sometimes
                        conversationId: activeConversation?.conversationId // Will always be there
                    },
                ]);

                setMessageText("");
                setAttachmentUrl(null);

                scrollToBottom();


            } catch (error) {
                console.error("Message send failed: ", error);
                //setReconnect(true)
                //alert("Connection is not active. Reconnecting...");
                toast.error("Failed to send message. Attempting to reconnect...");
            }
        } else {
            alert("Unable to send message. Connection is still inactive.");
            //setReconnect(true)
        }
    };


    return (
        <>
            {activeConversation ? (
                <>
                    <ChatNavbar activeConversation={activeConversation} notification={notification} setNotification={setNotification} onBack={onBack} />
                    <div className="chatbox-content">

                        <div className="chatting-wrapper" ref={chatContainerRef} onScroll={handleScroll}>

                        {isLoading && page > 1 && <div className="loading-spinner">Loading older messages...</div>}

                        {jobCardDetails && (
                            <div className="job-card">
                                <h3 className="job-title">{jobCardDetails?.jobTitle}</h3>
                                <div className="job-details">
                                    <div className="job-quote">
                                        <strong>Quote Amount:</strong> ${jobCardDetails?.quoteAmount}
                                    </div>
                                    <div className="job-description">
                                        <strong>Description:</strong> {jobCardDetails?.jobDescription}
                                    </div>
                                </div>

                                {/*
                                {jobCardDetails.jobId && (jobCardDetails.assignedBusinessId == activeConversation.businessId) ? (
                                    <button className="hire-button">Hired</button>

                                ) : (
                                    <button onClick={() => clickToHire(jobCardDetails.jobId)} className="hire-button" disabled={isHiring}>{isHiring ? "Hiring..." : "Hire for Job"}</button>
                                )
                                }
                                */}
                            </div>
                        )}

{
  messages.length > 0 ? (
    messages.map((message, index) => {
      const emojiOnlyRegex =
        /^(?:\p{Emoji_Presentation}|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Component}|\u200d)+$/u;
      const isEmojiOnly =
        message.message && emojiOnlyRegex.test(message.message.trim());

      // Show date separator when this message is on a different day than the previous one
      const prevMessage = index > 0 ? messages[index - 1] : null;
      const showDateSeparator = !prevMessage || isDifferentDay(prevMessage?.rawDate, message?.rawDate);

      return (
        <div
          key={message.id}
          ref={(el) => (messageRefs.current[message.messageId] = el)} // Store ref for each message by messageId
        >
          {showDateSeparator && message?.rawDate && (
            <div className="chat-date-separator">
              <span>{formatDateSeparator(message.rawDate)}</span>
            </div>
          )}
          {/* Conditional rendering based on message type */}
          {message.type === "receiver" ? (
            <>
              {!message?.attachmentUrl && (
                <div className="chat-msg">
                                                    <figure class="chat-person">
                                                        {/* --- CHANGE 3: CONDITIONAL AVATAR --- */}
                                                        {activeConversation?.userProfileUrl ? (
                                                            <img
                                                                src={activeConversation.userProfileUrl}
                                                                alt="User"
                                                            />
                                                        ) : (
                                                            <Avatar2 name={activeConversation?.userName} />
                                                        )}
                                                    </figure>


                  <div class="chat-msg-time">
                    <div className={`chat-msg-box ${isEmojiOnly ? "emoji-only" : ""}`}>
                      {message.message}
                    </div>
                    <span class="chat-time">{message.messageTime}</span>
                  </div>
                </div>
              )}

              {message?.attachmentUrl !== null && (
                <div>
                  <div className="chat-msg">
                                                    <figure class="chat-person">
                                                         {/* --- CHANGE 4: CONDITIONAL AVATAR --- */}
                                                        {userLoggedInImage ? (
                                                            <img
                                                                src={userLoggedInImage}
                                                                alt="User"
                                                            />
                                                        ) : (
                                                            <Avatar2 name={username} />
                                                        )}
                                                    </figure>

                    <div class="chat-msg-time">
                      <div class="chat-msg-box">
                        {/* Image with Default Blur and Download Icon */}
                        <div className="chat-attachment">
                          <div class="attachment-download">
                            <img
                              src={
                                message?.attachmentExtension === ".pdf"
                                  ? pdfIcon
                                  : message.attachmentUrl
                              }
                              alt="Upload Image" loading="lazy" 
                            />
                            <button
                              onClick={async () => {
                                try {
                                  // Fetch the file from the URL
                                  const response = await fetch(message.attachmentUrl);
                                  if (!response.ok) {
                                    throw new Error("Network response was not ok");
                                  }
                                  const blob = await response.blob();

                                  const url = new URL(message.attachmentUrl);
                                  const fileName = url.pathname.split("/").pop();

                                  const link = document.createElement("a");
                                  link.href = URL.createObjectURL(blob);
                                  link.download = fileName;
                                  link.style.display = "none";
                                  document.body.appendChild(link);
                                  link.click();

                                  URL.revokeObjectURL(link.href);
                                  document.body.removeChild(link);
                                } catch (error) {
                                  console.error("Download failed:", error);
                                }
                              }}
                              title="Download"
                              className="flex items-center justify-center"
                            >
                              <img src={downloadIcon} alt="Download Icon" />
                            </button>
                          </div>
                          {/* Blurred Background Image */}
                          {message.message}
                        </div>
                      </div>
                      <span class="chat-time">{message.messageTime}</span>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              {!message?.attachmentUrl && (
                <div class="chat-msg chat-sent">
                  <figure class="chat-person">
                    <img
                      src={userLoggedInImage == null ? EmptyProfileImage : userLoggedInImage}
                      alt="User Image"
                    />
                  </figure>
                  <div class="chat-msg-time">
                    <div className={`chat-msg-box ${isEmojiOnly ? "emoji-only" : ""}`}>
                      {message.message}
                    </div>
                    <span class="chat-time"> {message.messageTime}</span>
                  </div>
                </div>
              )}

              {message?.attachmentUrl && (
                <div class="chat-msg chat-sent">
                  <figure class="chat-person">
                    <img
                      src={userLoggedInImage == null ? EmptyProfileImage : userLoggedInImage}
                      alt="User Image"
                    />
                  </figure>
                  <div class="chat-msg-time">
                    <div class="chat-msg-box">
                      <div class="chat-attachment">
                        <img
                          src={
                            message?.attachmentExtension === ".pdf"
                              ? pdfIcon
                              : message.attachmentUrl
                          }
                          alt="Upload Image" loading="lazy"
                        />
                      </div>
                      {message.message}
                    </div>
                    <span class="chat-time">{message.messageTime}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      );
    })
  ) : (
    <div>
      {textNoMsg ? (
        <div class="messaging-center start-msg">
          <img src={StartConversation} />
          <h6>No Messages Yet</h6>
          <p>
            You haven't chatted with this contact yet. Send a message to start the
            conversation!
          </p>
        </div>
      ) : (
        "loading..."
      )}
    </div>
  )
}
                            
                            <div ></div>
                        </div>


                        <div class="send-chat-actions">
                            {!filePreview && (
                                <div class="chat-hint-labels">
                                    {/* <div class="hint-label">
                                        Let’s do it
                                    </div>
                                    <div class="hint-label">
                                        Great!
                                    </div>
                                    <div class="hint-label">
                                        Great!
                                    </div> */}
                                </div>
                            )}


                            <div>
                                <InputMessage className="send-chat-actions"
                                    filePreview={filePreview}
                                    setFilePreview={setFilePreview}
                                    onSendMessage={handleSendMessage}
                                    setAttachmentUrl={setAttachmentUrl}
                                />
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div class="messaging-center start-msg">
                    <img src={StartConversation} />
                    <h6>
                        Select a Contact to Start a Conversation
                    </h6>
                    <p>Choose a contact from your list to begin chatting and stay connected.</p>
                </div>
            )}
        </>

    );
}

export default Index;
